"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSideNavDrawer = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const AppSideNav_1 = require("./AppSideNav");
const AppSideNavButton_1 = __importDefault(require("./AppSideNavButton"));
const makeMyClasses = (collapse = false, depth = 0) => {
    const backgroundColor = !depth
        ? lib_palette_1.default.HelixSecondaryBoldAccent.main
        : lib_palette_1.default.HelixBackgroundPrimarySubtleHighlight.main;
    const borderColor = !depth ? lib_palette_1.default.HelixSecondaryBoldAccent.main : lib_palette_1.default.LineGrey.main;
    const left = depth == 0 ? 0 : depth === 1 ? AppSideNav_1.NAV_WIDTH_COLLAPSE : AppSideNav_1.NAV_WIDTH_COLLAPSE + AppSideNav_1.SUB_NAV_WIDTH;
    const width = collapse ? AppSideNav_1.NAV_WIDTH_COLLAPSE : depth == 0 ? AppSideNav_1.NAV_WIDTH : AppSideNav_1.SUB_NAV_WIDTH;
    return {
        root: {
            position: 'absolute',
            transition: 'width 0.32s, border 0.32s',
            left,
            width,
            minWidth: width,
            height: '100%',
            zIndex: 1000,
            padding: '16px 8px',
            textAlign: 'center',
            backgroundColor,
            borderRight: `1px solid ${borderColor}`,
        },
        inner: {
            // overflow: 'hidden',
            marginBottom: !depth ? 80 : 0,
        },
        container: {
            marginBottom: !depth ? 22 : 16,
        },
        logo: {
            width: 'calc(100% - 24px)',
            margin: '10px 10px 32px 10px',
        },
        logoCollapse: {
            width: 'calc(100% - 23px)',
            margin: '10px 10px 32px 10px',
        },
    };
};
function AppSideNavDrawer(props) {
    const { depth = 0, navs = [], collapse = false } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [collapse, depth]);
    return (0, react_1.useMemo)(() => {
        if (!(navs === null || navs === void 0 ? void 0 : navs.length))
            return null;
        return (react_1.default.createElement(Vertical_1.default, { classes: { root: (0, web_css_1.cx)(myCss.root, myCss['level' + depth]) } },
            !depth && !collapse && (react_1.default.createElement(Horizontal_1.default, { shrink: true, centered: true },
                react_1.default.createElement("img", { alt: "", src: "/assets/images/logo.svg", className: myCss.logo }))),
            !depth && collapse && (react_1.default.createElement(Horizontal_1.default, { shrink: true, centered: true },
                react_1.default.createElement("img", { alt: "", src: "/assets/images/logo-only-white.svg", className: myCss.logoCollapse }))),
            react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: myCss.inner } }, navs.map((nav, idx) => (react_1.default.createElement("div", { key: 'appnav' + idx, className: myCss.container },
                react_1.default.createElement(AppSideNavButton_1.default, { appNav: nav, depth: depth, collapse: collapse }),
                nav.dividerBelow && (react_1.default.createElement(Divider_1.default, { style: { marginTop: 14 }, color: lib_palette_1.default.BlackCoral }))))))));
    }, [collapse, depth, myCss, navs]);
}
exports.AppSideNavDrawer = AppSideNavDrawer;
exports.default = AppSideNavDrawer;
